import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../TrueGrit";
import {TrueGritStatics} from "../TrueGritStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

/**
 * Created by Jerker Nord on 2021-09-16.
 */

export class TrueGritWildTransformView extends PIXI.Container implements StageLayer {

    private static WILD_TRANSFORM_OFFSET:PIXI.Point = new PIXI.Point(86, 72);
    private static WILD_TRANSFORM_TOP_REEL_OFFSET:PIXI.Point = new PIXI.Point(73, -46);
    private static WILD_TRANSFORM_BOTTOM_REEL_OFFSET:PIXI.Point = new PIXI.Point(86, -120);

    private _wildTransforms:PIXI.spine.Spine[][];

    constructor() {
        super();
        this.name = "TrueGritWildTransformView";
        this.init();
    }

    private init() {
        this._wildTransforms = [];
        let tempWildTransformAnimation:PIXI.spine.Spine;
        for(let i:number = 0; i < 6; i++) {
            const subWildTransforms:PIXI.spine.Spine[] = [];
            if(i > 0 && i < 4) {
                for(let j:number = 0; j < 5; j++) {
                    tempWildTransformAnimation = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.TRANSFORM_TO_WILD_SPINE));
                    tempWildTransformAnimation.visible = false;
                    this.addChild(tempWildTransformAnimation);
                    subWildTransforms.push(tempWildTransformAnimation);
                }
            }

            this._wildTransforms.push(subWildTransforms);
        }
        this._wildTransforms = [];
        let tempWildFastTransformAnimation:PIXI.spine.Spine;
        for(let i:number = 0; i < 6; i++) {
            const subWildTransforms:PIXI.spine.Spine[] = [];
            if(i > 0 && i < 4) {
                for(let j:number = 0; j < 5; j++) {
                    tempWildFastTransformAnimation = new PIXI.spine.Spine(TrueGrit.assetLoader.getSpineAsset(TrueGritGameAssets.TRANSFORM_TO_WILD_SPINE));
                    tempWildFastTransformAnimation.visible = false;
                    this.addChild(tempWildFastTransformAnimation);
                    subWildTransforms.push(tempWildFastTransformAnimation);
                }
            }

            this._wildTransforms.push(subWildTransforms);
        }

        //Push animation to GPU
        const wildTransformTextures:PIXI.Texture[] = TrueGrit.assetLoader.getTextures("winAnimations/wildTranform/wTransfrom_");
        for(let i:number = 0; i < wildTransformTextures.length; i++) {
            TrueGrit.gpuPushView.addChild(new PIXI.Sprite(wildTransformTextures[i]));
        }
        const wildEmberTextures:PIXI.Texture[] = TrueGrit.assetLoader.getTextures("winAnimations/wild_ember_frame/w_ember_frame_");
        for(let i:number = 0; i < wildEmberTextures.length; i++) {
            TrueGrit.gpuPushView.addChild(new PIXI.Sprite(wildEmberTextures[i]));
        }

        this.onResize();
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public getWildTransformAnimation(splitLevel:number, symName:string, reel:number, row:number, symbolPosition:PIXI.Point, isFast:boolean):gsap.core.Timeline {
        let animationName = "";
        if (splitLevel < 2){
            animationName = "w_transform";
            if (isFast == true){
                animationName = "w_transform_nowin";
            }
        }else{
            animationName = "w_transform_on_split";
            if (isFast == true){
                animationName = "w_transform_nowin_on_split";
            }
        }
        if(row > 0 && row < 5) {
            if(reel > 1 && row == 4) {
                //Bottom reel
                this._wildTransforms[reel][row].position.x = TrueGritStatics.BOTTOM_REEL_VIEW_POSITION.x + symbolPosition.x + TrueGritWildTransformView.WILD_TRANSFORM_BOTTOM_REEL_OFFSET.x
                this._wildTransforms[reel][row].position.y = TrueGritStatics.BOTTOM_REEL_VIEW_POSITION.y + symbolPosition.y + TrueGritWildTransformView.WILD_TRANSFORM_BOTTOM_REEL_OFFSET.y;
            } else {
                //Main reels
                this._wildTransforms[reel][row].position.x = TrueGritStatics.MAIN_REELS_VIEW_POSITION.x + TrueGritStatics.reelPositions[reel].x + symbolPosition.x + TrueGritWildTransformView.WILD_TRANSFORM_OFFSET.x;
                this._wildTransforms[reel][row].position.y = symbolPosition.y + TrueGritWildTransformView.WILD_TRANSFORM_OFFSET.y;
            }
        } else {
            //Top reel
            this._wildTransforms[reel][row].position.x = symbolPosition.x + TrueGritWildTransformView.WILD_TRANSFORM_TOP_REEL_OFFSET.x;
            this._wildTransforms[reel][row].position.y = symbolPosition.y + TrueGritWildTransformView.WILD_TRANSFORM_TOP_REEL_OFFSET.y;
        }

        const wildTransformTL:gsap.core.Timeline = gsap.timeline();
        wildTransformTL.add(() => {
            this._wildTransforms[reel][row].updateTransform();
            this._wildTransforms[reel][row].visible = true;
            this._wildTransforms[reel][row].skeleton.setSkin(null);
            this._wildTransforms[reel][row].skeleton.setSkinByName(symName);
            this._wildTransforms[reel][row].skeleton.setSlotsToSetupPose();
        });
        wildTransformTL.add(new SpineTween(this._wildTransforms[reel][row], 0, animationName, 0).timeScale(1.5)); // #109
        wildTransformTL.add(() => {this._wildTransforms[reel][row].visible = false});

        return wildTransformTL;
    }
}